import { createContext } from 'react';

export type CarouselModalImageData = {
  src: string;
  alt?: string;
};

export type CarouselModalData = {
  slides: CarouselModalImageData[];
  currentIndex?: number;
  paginationSlides?: CarouselModalImageData[];
};

export type CarouselContextValue = {
  openModal: (data: CarouselModalData) => void;
  closeModal: () => void;
} | null;

export const CarouselContext = createContext<CarouselContextValue>(null);
